<template>
    <div>
        <div style="padding-left:20px;padding-right:20px;">
			<Form ref="productForm" label-position="left" :label-width="80" >
                <Row :gutter="16">		
					<Col span="16">
						<FormItem label="产品列表">                     
							<Select v-model="productSelectList" transfer multiple  filterable >
								<Option v-for="item in productList"
									:key="item.productUuid" :value="item.productUuid">
									{{ item.productName }}
								</Option>
							</Select>
						</FormItem>
                    </Col>	
                    <Col span="8">
                        <Button type="success"
                            class="btns"
                            shape="circle"          
                            @click="selectAllProduct">全选</Button>	
                        <Button type="warning"
                            class="btns"
                            shape="circle"          
                            @click="deleteSelectList">清空选项</Button>	
                        <Button type="primary"
                            class="btns"
                            shape="circle"          
                            @click="AddProductsData">选项添加</Button>	
                            <Button type="error"
                            class="btns"
                            shape="circle"          
                            @click="deleteProductsData">清空列表</Button>
                      			
                    </Col>			
				</Row>	
					

			
            </Form>
		</div>
        <Card>
            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table ref="mainTable" :columns="mainTable.tableColumns" :data="mainTable.tableData"
                    :loading="mainTable.tableLoading" :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" :showPage="false" />
                </Col>
            </Row>
        </Card>
    </div>

</template>
<script>
import { getProductList } from '@/api/modules/product-management/product-management';
import { getAllProductList } from '@/api/modules/sale-management/sale-approve';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
export default {
    name:"productPopupEditTabBathProductList",
    components: {
        StandPaginationTable
    },
    data() {
        return {
            productSelectList:[],
            productList:[],
            templateProdcuctId:'',
            mainTable: {
                tableColumns: [
                    // { type: 'selection', width: 60, align: 'center' },
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '苗场', key: 'seedFarmName', align: 'center', excel: true },
                    { title: '大类', key: 'mainCategoryName', align: 'center', excel: true },
                    { title: '小类', key: 'subCategoryName', align: 'center', excel: true },
                    { title: '品牌', key: 'brandName', align: 'center', excel: true },
                    { title: '编号', key: 'productCode', align: 'center', excel: true },
                    { title: '名称', key: 'productName', width: 160, align: 'center', excel: true },
                    { title: '编辑模板', key: '', align: 'center', excel: true,              
                        render: (h, params) => {
                            return h('span', { style:{ color:'#19BE6B' } }, params.row.productUuid==this.templateProdcuctId? '模板项':'');                            
                        } 
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 220,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    on: {
                                        click: () => {
                                            this.deleteProduct(params.row);
                                        }
                                    }
                                }, '删除'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: { visibility:this.templateProdcuctId!=params.row.productUuid? 'visible' : 'hidden' },
                                    on: {
                                        click: () => {
                                            this.selectProductTemplate(params.row.productUuid);
                                        }
                                    }
                                }, '设置模板')
                            ]);
                        }
                    }

                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getAllProductList();
    },
    methods:{  
        AddProductsData(){
            let list=JSON.parse(JSON.stringify(this.mainTable.tableData));
            this.productSelectList.forEach(id=>{
                let product= this.productList.find(item=>item.productUuid==id);
                list.push(product);
            
            });
            list= Array.from(new Set(list.map(JSON.stringify)), JSON.parse);
            list.sort((a, b)=> a.productCode.localeCompare(b.productCode));
            this.mainTable.tableData=list;
        },  
        deleteSelectList(){
            this.productSelectList=[];
        },
        selectAllProduct(){
            this.productSelectList=this.productList.map(item=>item.productUuid);
        },
        deleteProduct(row){
            if(this.templateProdcuctId==row.productUuid){
                this.selectProductTemplate("");
            }
            this.mainTable.tableData=this.mainTable.tableData.filter(item=>item.productUuid!=row.productUuid);
        },
        deleteProductsData(){
            this.mainTable.tableData=[];
            this.selectProductTemplate("");
        },
        selectProductTemplate(productUuid){
            this.templateProdcuctId=productUuid;           
            this.$emit('chang-template-product', this.templateProdcuctId);
        },
        getAllProductList(){
            let condition = this.getCondition(); 
            condition.filters.conditions.push({
                name: 'isShow',
                type: 'eq',
                value: 1
            });
         
            getProductList(condition).then(res => {
                if (res.code === 0) {
                    this.productList = res.data.records;                 
                } 
            });
        },
        init(productUuids){
            this.productSelectList=[];
            this.getMainTableRecords(productUuids);
        },
        getMainTableRecords(productUuids) {  
            let condition =this.getCondition();          
            let productUuidsStr=productUuids&&productUuids.length>0?JSON.stringify(productUuids): JSON.stringify([]) ;           
        
            if(productUuids&&productUuids.length>0){
                this.selectProductTemplate(productUuids[0]);
            }
            else{
                this.selectProductTemplate('');
            }

  
            condition.filters.conditions.push({
                name: 'productUuid',
                type: 'in',
                value: productUuidsStr
            });

            condition.filters.conditions.push({
                name: 'isShow',
                type: 'eq',
                value: 1
            });

            this.mainTable.tableLoading = true;
            getProductList(condition).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;                 
                }
                this.mainTable.tableLoading = false;
            });
        },
        getCondition(){
            let condition = {
                filters: {
                    enable: true,
                    conditions: []
                },
                order: {
                    enable: false,
                    conditions: []
                },
                limit: {
                    enable: false,
                    conditions: {
                        pageLength: 10,
                        pageStart: 1,
                        total: 0
                    }
                },
                excelExport: {
                    enable: false,
                    columns: []
                }
            };   
            return condition;
        }
    }
};
</script>